export const APPROVER = 'approver';
export const VERIFIER = 'verifier';
